import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ArrowUp = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { "fillRule": "evenodd", "clipRule": "evenodd", d: "M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L18.7071 10.2929C19.0976 10.6834 19.0976 11.3166 18.7071 11.7071C18.3166 12.0976 17.6834 12.0976 17.2929 11.7071L13 7.41421V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V7.41421L6.70711 11.7071C6.31658 12.0976 5.68342 12.0976 5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929L11.2929 4.29289Z" })));
};
export default ArrowUp;
